/**
 * A global namespace for `resize` event.
 * @type {string}
 */
const resizeEvent = 'resize';
export default resizeEvent;
